/* eslint-disable complexity */
import * as React from 'react';
import cx from 'classnames';
import {TopicModule} from '@/services/pages/channel/channel.client';
import {
    SELF_TOPIC_CONTAINER,
    SELF_TOPIC_CONTAINER_TYPE_H,
    SELF_TOPIC_CONTAINER_TYPE_MIX,
    SELF_TOPIC_CONTAINER_TYPE_V,
    SELF_TOPIC_CONTENT_NAME,
    SELF_TOPIC_CONTENT_TYPE_FLOW_BIG,
    SELF_TOPIC_CONTENT_TYPE_FLOW_SMALL,
    SELF_TOPIC_CONTENT_TYPE_HORIZONTAL,
    SELF_TOPIC_CONTENT_TYPE_SINGLEABS,
    SELF_TOPIC_EXPERT,
    SELF_TOPIC_IMAGE_NAME,
    SELF_TOPIC_IMAGE_TYPE_BANNER,
    SELF_TOPIC_IMAGE_TYPE_DOUBLE_COLUMN,
    SELF_TOPIC_IMAGE_TYPE_GOLD_ICON,
    SELF_TOPIC_IMAGE_TYPE_HORIZONTAL,
    SELF_TOPIC_IMAGE_TYPE_SPECIAL_DOUBLE_COLUMN,
    SELF_TOPIC_IMAGE_TYPE_SWIPER,
    SELF_TOPIC_TOFU_CUBE_NAME,
    SELF_TOPIC_IMAGE_TYPE_SEAMLESS_SPLICING,
    // 图片模块 - value:19 图片大尺寸样式
    SELF_TOPIC_BIG_WIDTH_TYPE_HORIZONTAL,
} from '@/dicts/modelConsts';
import SelfTopicContentFlowBig from '@/components/flowBig';
import SelfTopicContentFlowSmall from '@/components/flowSmall';
import SelfTopicContentHorizontal from '@/pages/specialDisease/hotContent';
import DiseaseBannerSwipe from '@/pages/specialDisease/swiper';
import SelfTopicImageHorizontal from '@/components/imgHorizontal';
import DiseaseGoldIcons from '@/pages/specialDisease/goldIcons';
import SelfTopicImgDoubleColumn from '@/components/doubleColumn';
import SelfTopicTofuText from '@/components/tofuText';
import SelfTopicImgSpecialDoubleColumn from '@/components/specialDoubleColumn';
import VideoSwpier from '@/pages/specialDisease/videoSwiper';
import {VALUE_TYPE} from '@/dicts/consts';
import SelfTopicExpert from '../selfTopicExpert';
import Title from '../common/title';
import SelfTopicContainerHorizontal from '../containerHorizontal';
import SelfTopicContainerAggregation from '../SelfTopicContainerAggregation';
import SelfTopicContentSingleAbstract from '../common/singleAbstract';
import SeamlessPuzzle from '../seamlessPuzzle';
import styles from './index.less';

interface Props {
    page: string;
    sfRef?: string;
    channelBusinessLine?: string;
    infos: TopicModule;
}

const SelfTopicContainerVertical = ({infos, page, sfRef, channelBusinessLine}: Props) => {

    const getCusStyle = (moduleItem: TopicModule) => {
        const styleObj = {
            backgroundColor: moduleItem.moduleBgc ? moduleItem.moduleBgc : 'white',
            borderRadius: moduleItem.moduleFillet === 1 ? '0' : '12px',
            marginRight: moduleItem.moduleSpace === 1 ? '0' : '10px',
            marginLeft: moduleItem.moduleSpace === 1 ? '0' : '10px',
            marginTop: moduleItem.moduleSpaceBack === 1 ? '0' : '8px',
        };
        return styleObj ?? {};
    };

    return (
        <div
            data-show={JSON.stringify({
                'page': page,
                'value': 'jump_rongqi_shuxiang',
                'pageSourceId': infos.channelId,
                'pageType': channelBusinessLine,
                'valueId': infos.moduleId,
                'valueTitle': infos.moduleName,
                'valueType': VALUE_TYPE.MODULE,
            })}
        >
            {
                infos.isShowTitle === 1 && (infos.moduleName || infos.moduleSubTitle)
                && (
                    <div className={styles.titleWrap}>
                        <Title
                            title={infos.moduleName ?? ''}
                            subTitle={infos.moduleSubTitle ?? ''}
                            moreLink={infos.moreUrl ?? ''}
                            ubcExt={{
                                page: page,
                                value: 'jump_rongqi_gengduo',
                                pageSourceId: infos.channelId,
                                pageType: channelBusinessLine ?? '',
                                valueId: infos.moduleId,
                                valueTitle: infos.moduleName ?? '',
                            }}
                        />
                    </div>
                )
            }

            {
                infos.subModuleList?.map(
                    // eslint-disable-next-line array-callback-return
                    module => {
                        switch (module.moduleEnName) {
                            case SELF_TOPIC_IMAGE_NAME:
                                switch (module.moduleStyle) {
                                    case SELF_TOPIC_IMAGE_TYPE_BANNER:
                                        return (
                                            module?.itemList?.length
                                                ? (
                                                    <div
                                                        style={getCusStyle(module)}
                                                        className={styles(styles.cardBg, styles.noTopPadding)}
                                                    >
                                                        <DiseaseBannerSwipe
                                                            page={page}
                                                            sfRef={sfRef}
                                                            channelBusinessLine={channelBusinessLine}
                                                            bannersModel={module}
                                                        />
                                                    </div>
                                                )
                                                : null
                                        );
                                    case SELF_TOPIC_IMAGE_TYPE_HORIZONTAL:
                                    case SELF_TOPIC_BIG_WIDTH_TYPE_HORIZONTAL:
                                        return (
                                            module?.itemList?.length
                                                ? (
                                                    <div
                                                        style={getCusStyle(module)}
                                                        className={styles.cardBg}
                                                    >
                                                        <SelfTopicImageHorizontal
                                                            page={page}
                                                            sfRef={sfRef}
                                                            infos={module}
                                                            channelBusinessLine={channelBusinessLine}
                                                        />
                                                    </div>
                                                )
                                                : null
                                        );
                                    case SELF_TOPIC_IMAGE_TYPE_GOLD_ICON:
                                        return (
                                            module?.itemList?.length
                                                ? (
                                                    <div
                                                        style={getCusStyle(module)}
                                                        className={styles.cardBg}
                                                    >
                                                        <DiseaseGoldIcons
                                                            page={page}
                                                            sfRef={sfRef}
                                                            channelBusinessLine={channelBusinessLine}
                                                            goldIcons={{
                                                                channelId: module.channelId,
                                                                golds: module.itemList,
                                                                moduleMaxColumns: module.moduleMaxColumns,
                                                                moduleName: module.moduleName,
                                                            }}
                                                        />
                                                    </div>
                                                )
                                                : null
                                        );
                                    case SELF_TOPIC_IMAGE_TYPE_DOUBLE_COLUMN:
                                        return (
                                            module?.itemList?.length
                                                ? (
                                                    <div
                                                        style={getCusStyle(module)}
                                                        className={styles.cardBg}
                                                    >
                                                        <SelfTopicImgDoubleColumn
                                                            page={page}
                                                            sfRef={sfRef}
                                                            channelBusinessLine={channelBusinessLine}
                                                            infos={module}
                                                        />
                                                    </div>
                                                )
                                                : null
                                        );
                                    case SELF_TOPIC_IMAGE_TYPE_SPECIAL_DOUBLE_COLUMN:
                                        return (
                                            module?.itemList?.length
                                                ? (
                                                    <div
                                                        style={getCusStyle(module)}
                                                        className={styles.cardBg}
                                                    >
                                                        <SelfTopicImgSpecialDoubleColumn
                                                            page={page}
                                                            sfRef={sfRef}
                                                            channelBusinessLine={channelBusinessLine}
                                                            infos={module}
                                                        />
                                                    </div>
                                                )
                                                : null
                                        );
                                    case SELF_TOPIC_IMAGE_TYPE_SWIPER:
                                        return (
                                            module?.itemList?.length
                                                ? (
                                                    <div
                                                        id={module.moduleId?.toString()}
                                                        key={module.moduleId}
                                                        style={getCusStyle(module)}
                                                        className={styles(styles.cardBg, styles.noTopPadding)}
                                                    >
                                                        <VideoSwpier
                                                            page={page}
                                                            channelBusinessLine={channelBusinessLine}
                                                            sfRef={sfRef}
                                                            bannersModel={module}
                                                            ubcValue="jump_shipinlunbo"
                                                        />
                                                    </div>
                                                )
                                                : null
                                        );
                                    case SELF_TOPIC_IMAGE_TYPE_SEAMLESS_SPLICING:
                                        return (
                                            module?.itemList?.length
                                                ? (
                                                    <div
                                                        style={getCusStyle(module)}
                                                        className={styles(styles.cardBg, styles.noTopPadding)}
                                                    >
                                                        <SeamlessPuzzle
                                                            page={page}
                                                            sfRef={sfRef}
                                                            infos={module}
                                                            channelBusinessLine={channelBusinessLine}
                                                            ubcValue="jump_wufengpinjie"
                                                        />
                                                    </div>
                                                )
                                                : null
                                        );
                                }
                                break;
                            case SELF_TOPIC_TOFU_CUBE_NAME:
                                return (
                                    module?.itemList?.length
                                        ? (
                                            <div
                                                style={getCusStyle(module)}
                                                className={styles.cardBg}
                                            >
                                                <SelfTopicTofuText
                                                    page={page}
                                                    sfRef={sfRef}
                                                    channelBusinessLine={channelBusinessLine}
                                                    infos={module}
                                                />
                                            </div>
                                        )
                                        : null
                                );
                            case SELF_TOPIC_CONTENT_NAME:
                                switch (module.moduleStyle) {
                                    case SELF_TOPIC_CONTENT_TYPE_HORIZONTAL:
                                        return (
                                            module?.itemList?.length
                                                ? (
                                                    <div
                                                        style={getCusStyle(module)}
                                                        className={styles.cardBg}
                                                    >
                                                        <SelfTopicContentHorizontal
                                                            page={page}
                                                            sfRef={sfRef}
                                                            channelBusinessLine={channelBusinessLine}
                                                            infos={module}
                                                        />
                                                    </div>
                                                )
                                                : null
                                        );
                                    case SELF_TOPIC_CONTENT_TYPE_FLOW_SMALL:
                                        return (
                                            module?.itemList?.length
                                                ? (
                                                    <div
                                                        style={getCusStyle(module)}
                                                        className={styles.cardBg}
                                                    >
                                                        <SelfTopicContentFlowSmall
                                                            page={page}
                                                            sfRef={sfRef}
                                                            infos={module}
                                                            channelBusinessLine={channelBusinessLine}
                                                            innerModel
                                                        />
                                                    </div>
                                                )
                                                : null
                                        );
                                    case SELF_TOPIC_CONTENT_TYPE_FLOW_BIG:
                                        return (
                                            module?.itemList?.length
                                                ? (
                                                    <div
                                                        style={getCusStyle(module)}
                                                        className={styles.cardBg}
                                                    >
                                                        <SelfTopicContentFlowBig
                                                            page={page}
                                                            channelBusinessLine={channelBusinessLine}
                                                            sfRef={sfRef}
                                                            infos={module}
                                                        />
                                                    </div>
                                                )
                                                : null
                                        );
                                    case SELF_TOPIC_CONTENT_TYPE_SINGLEABS:
                                        return (
                                            module?.itemList && module.itemList?.length
                                                ? (
                                                    <div
                                                        key={module.moduleId}
                                                        style={getCusStyle(module)}
                                                        className={cx(
                                                            styles.cardBg,
                                                            {
                                                                [styles.noPaddingCBg]: module.isShowTitle === 2,
                                                            }
                                                        )}
                                                    >
                                                        <SelfTopicContentSingleAbstract
                                                            page={page}
                                                            channelBusinessLine={channelBusinessLine}
                                                            sfRef={sfRef}
                                                            infos={module}
                                                        />
                                                    </div>
                                                )
                                                : null
                                        );
                                }
                                break;
                            case SELF_TOPIC_EXPERT:
                                return (
                                    module?.itemList?.length
                                        ? (
                                            <div
                                                style={getCusStyle(module)}
                                                className={styles(styles.cardBg, styles.noTopPadding)}
                                            >
                                                <SelfTopicExpert
                                                    page={page}
                                                    channelBusinessLine={channelBusinessLine}
                                                    sfRef={sfRef}
                                                    infos={module}
                                                />
                                            </div>
                                        )
                                        : null
                                );
                            case SELF_TOPIC_CONTAINER:
                                switch (module.moduleStyle) {
                                    case SELF_TOPIC_CONTAINER_TYPE_H:
                                        return (
                                            module?.subModuleList?.length
                                                ? (
                                                    <div
                                                        style={getCusStyle(module)}
                                                        className={styles.cardBg}
                                                    >
                                                        <SelfTopicContainerHorizontal
                                                            page={page}
                                                            channelBusinessLine={channelBusinessLine}
                                                            sfRef={sfRef}
                                                            infos={module}
                                                        />
                                                    </div>
                                                )
                                                : null
                                        );
                                    case SELF_TOPIC_CONTAINER_TYPE_V:
                                        return (
                                            module?.subModuleList?.length
                                                ? (
                                                    <div
                                                        style={getCusStyle(module)}
                                                        className={styles.cardBg}
                                                    >
                                                        <SelfTopicContainerVertical
                                                            page={page}
                                                            channelBusinessLine={channelBusinessLine}
                                                            sfRef={sfRef}
                                                            infos={module}
                                                        />
                                                    </div>
                                                )
                                                : null
                                        );
                                    case SELF_TOPIC_CONTAINER_TYPE_MIX:
                                        return (
                                            module?.subModuleList?.length
                                                ? (
                                                    <div
                                                        style={getCusStyle(module)}
                                                        className={styles.cardBg}
                                                    >
                                                        <SelfTopicContainerAggregation
                                                            page={page}
                                                            channelBusinessLine={channelBusinessLine}
                                                            sfRef={sfRef}
                                                            infos={module}
                                                        />
                                                    </div>
                                                )
                                                : null
                                        );

                                }
                        }

                    }
                )

            }

        </div>
    );
};

export default SelfTopicContainerVertical;
